import { render, staticRenderFns } from "./MfcTextarea.vue?vue&type=template&id=2017169e&scoped=true&"
import script from "./MfcTextarea.vue?vue&type=script&lang=js&"
export * from "./MfcTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MfcTextarea.vue?vue&type=style&index=0&id=2017169e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2017169e",
  null
  
)

export default component.exports